import BaseService from "@/service/base.service";

const state = {
  DivNo: "",
  DivName: "",
  DivShortName: "",
  EmpName: "",
  EmpID: "",
  PostionName: "",
  CompID: "",
  Roles: [],
  CathayNo: ""
};

const getters = {
  user: state => state
};

const isDev = process.env.VUE_APP_NODE_ENV === "development";

const actions = {
  login() {
    const redirectBase = `${process.env.VUE_APP_LOCAL_PROXY_HOST}${process.env.VUE_APP_API_HOST}/`;
    // 部署上去各環境後, 會使用 spring security 的方式導頁至登入畫面, 因此只需處理本機測試階段
    if (isDev) {
      const devUrl = btoa(window.location.href);
      window.location.assign(`${redirectBase}?devUrl=${devUrl}`);
    }
  },
  getUserObject({ commit }, obj) {
    return new Promise((resolve, rejects) => {
      this._vm.$cathayAxios.get(BaseService.getUserObject, obj).then(resp => {
        if (resp.returnCode === 0) {
          commit("setUser", resp.data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  isLoggedIn({ commit }, obj) {
    // 處理登入邏輯.
    return new Promise((resolve, rejects) => {
      this._vm.$cathayAxios.get(BaseService.isLoggedIn, obj).then(resp => {
        resolve(resp);
      });
    });
  },
  logout({ commit }, obj) {
    let logoutURL = this._vm.$conf.LOGOUT_URL;
    if (isDev) {
      logoutURL = `${process.env.VUE_APP_LOCAL_PROXY_HOST}${this._vm.$conf.LOGOUT_URL}`;
    }
    window.location.href = logoutURL;
  }
};

const mutations = {
  setUser(state, obj) {
    if (obj) {
      state.DivNo = obj.divNo;
      state.DivName = obj.divFullName;
      state.DivShortName = obj.divShortName;
      state.EmpName = obj.empName;
      state.EmpID = obj.empID;
      state.PostionName = obj.cepsnnm;
      state.CompID = obj.compID;
      state.Roles = obj.roles;
      state.CathayNo = obj.cathayNo;
    } else {
      state.DivNo = "";
      state.DivName = "";
      state.DivShortName = "";
      state.EmpName = "";
      state.EmpID = "";
      state.PostionName = "";
      state.CompID = "";
      state.Roles = [];
      state.CathayNo = "";
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
